import React from 'react'
import { lifecycle } from 'recompose'
import PropTypes from 'prop-types'
import withLayout from '../../../layout/withLayout'
import ContentBox from '../../../layout/component/ContentBox'
import getColumnList from './appointment-column-list'
import Table from '../../../table/component/Table'
import { getStoreDropDown } from '../../../store/util/renderStoreName'
import { CANCEL_CATEGORY } from '../detail/AppointmentDetail'
import { APPOINTMENT_TYPE } from '../../state/search/const'
import TableColumnSelector from "../../../table/component/TableColumnSelector"
import { COUNTRY_CODE_LIST } from '../../../internationalization/const'

const AppointmentSearch = ({ tableData, changeFilter, toggleSort, toggleMultiSort, gotoPage, isTablet, navigateToAppointment, toggleColumnVisibility }) => {
    const columnList = getColumnList(isTablet);
    return (
        <ContentBox title="Appointment">

            <TableColumnSelector
                resultsNumber={tableData.objectList.length}
                hiddenColumns={tableData.hiddenColumns}
                columnList={columnList}
                toggleColumnVisibility={toggleColumnVisibility}
            />


            <Table
                {...tableData}
                changeFilter={changeFilter}
                toggleSort={toggleSort}
                toggleMultiSort={toggleMultiSort}
                gotoPage={gotoPage}
                idProperty="id"
                columnList={columnList}
                onRowClick={(appointment) => {
                    navigateToAppointment(appointment.id)
                }}
                filterSetting={{
                    cancelCategory: {
                        type: 'select',
                        valueList: CANCEL_CATEGORY,
                    },
                    storeId: {
                        type: 'select',
                        valueList: getStoreDropDown(),
                    },
                    countryCode: {
                        type: 'select',
                        valueList: COUNTRY_CODE_LIST,
                    },
                    status: {
                        type: 'input',
                        beforeQuery: (value) => {
                            if (!value) {
                                return value
                            }
                            return value.replace(/ /g, '_')
                        },
                        beforeRender: (value) => {
                            if (!value) {
                                return value
                            }
                            return value.replace(/_/g, ' ')
                        },
                    },
                    appointmentType: {
                        type: 'select',
                        valueList: APPOINTMENT_TYPE,
                    },
                }}
            />
        </ContentBox>
    )
}

AppointmentSearch.propTypes = {
    isTablet: PropTypes.bool.isRequired,
}

export default lifecycle({
    componentDidMount() {
        this.props.initialTableQuery()
        this.props.initialColumnsVisibility()
    },
})(withLayout(AppointmentSearch))



// WEBPACK FOOTER //
// ./src/modules/appointment/component/search/AppointmentSearch.js